import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Section1 from '../components/section_1/Section_1';
import Section2 from '../components/section_2/Section_2';
import Section3 from '../components/section_3/Section_3';
import Section4 from '../components/section_4/Section_4';
import Section5 from '../components/section_5/Section_5';
import Section6 from '../components/section_6/Section_6';
import Section7 from '../components/section_7/Section_7';
import Section8 from '../components/section_8/Section_8';
import Section9 from '../components/section_9/Section_9';
import Section10 from '../components/section_10/Section_10';
import Section11 from '../components/section_11/Section_11';
import Section12 from '../components/section_12/Section_12';
import SurveyForm2 from '../components/surveyform2/survey_form_2';
import ContactSection from '../components/surveyform1/survey_form_1';

function ContactPage({ config }) {
    if (!config ) return null;

    const renderSection = (key) => {
      switch (key) {
        case "section_1":
            return <Section1 heroConfig={config.section_1} />;
        case 'section_2':
            return <Section2 sectionConfig={config.section_2} />;
        case 'section_3':
            return <Section3 sectionConfig={config.section_3} />;
        case 'section_4':
            return <Section4 sectionConfig={config.section_4} />;
        case 'section_5':
            return <Section5 sectionConfig={config.section_5} />;
        case 'section_6':
            return <Section6 sectionConfig={config.section_6} />;
        case 'section_7':
            return <Section7 sectionConfig={config.section_7} />;
        case 'section_8':
            return <Section8 sectionConfig={config.section_8} />;
        case 'section_9':
            return <Section8 sectionConfig={config.section_9} />;
        case 'section_10':
            return <Section10 sectionConfig={config.section_10} />;
        case 'section_11':
            return <Section11 sectionConfig={config.section_11} />;
        case 'section_12':
            return <Section12 sectionConfig={config.section_12} />;
        case 'survey_form_2':
            return <SurveyForm2 sectionConfig={config.survey_form_2} />;
        case 'survey_form_1':
            return <ContactSection path={config.survey_form_1} office = { config.office_card } />;
        default:
            return null;
      }
    };

    return (
      <div className="services-page">
        {config.sequence.map((sectionKey) => renderSection(sectionKey))}
      </div>
    );
  }

// function renderSection(key) {
//     switch (key) { 
//       case 'section_1':
//         return <Section1 config={key} key={key} />;
//       case 'section_2':
//         return <Section2 config={key} key={key} />;
//       case 'section_3':
//         return <Section3 config={key} key={key} />;
//       case 'section_4':
//         return <Section4 config={key} key={key} />;
//       case 'section_5':
//         return <Section5 config={key} key={key} />;
//       case 'section_6':
//         return <Section6 config={key} key={key} />;
//       case 'section_7':
//         return <Section7 config={key} key={key} />;
//       case 'section_8':
//         return <Section8 config={key} key={key} />;
//         case 'section_9':
//           return <Section9 config={key} key={key} />;
//       default:
//         return null;
//     }
//   }
  
export default ContactPage;